module.exports = __webpack_public_path__ + "img/catC.34490384.svg";